<template>
    <div>
        <RaiseTab name="1">{{formData && formData.title}}</RaiseTab>
        <el-form
            :model="formData"
            ref="formData"
            label-position="top"
            v-loading="dataLoading"
        >
            <RasieBaseInfo v-if="formData" :formData.sync="formData" :reFresh="reFresh"></RasieBaseInfo>
        </el-form>
        <div class="page-group-box MT10">
            <el-button @click="goBack">返回</el-button>
            <el-button
                type="primary"
                @click="onSubmit"
                :loading="btnLoading"
                >保存</el-button
            >
        </div>
    </div>
</template>

<script>
import RaiseTab from './components/raise-tab';
import RasieBaseInfo from './components/raise-baseInfo';
const defaultFormData = {
    title:'',
    startTime:'',
    endTime:'',
    datetimerange:[],
    raiseType:1,
    raiseMoney:undefined,
    raiseModel:1,
    poster:'',
    posterOriginal:'',
    musicIds:[],
    introduce:'',
    status:0,
    promoterUserType:2
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components:{RaiseTab,RasieBaseInfo},
    data(){
        return {
            formData:{...defaultFormData},
            btnLoading: false,
            dataLoading: false,
            redirect: this.$route.query.redirect || "/raise/project/list",
            reFresh:false,
        }
    },
    created() {
        if (this.id) {
            this.getData();
        }else{
            this.reFresh = true;
        }
    },
    methods:{
        // 获取详情
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/raise/info",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...defaultFormData,
                        ...result,
                        datetimerange:result.startTime ? [result.startTime,result.endTime || result.startTime] : [],
                        musicIds: result.musics ? result.musics.map( v => v.musicId) : [],
                        raiseMoney: result.raiseMoneyFormat || result.raiseMoney || undefined
                    }
                    
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                    this.reFresh = true;
                });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.formData.startTime = this.formData.datetimerange[0];
                    this.formData.endTime = this.formData.datetimerange[1];

                    this.$request({
                        url: "/raise/publish/base",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$confirm('是否返回列表', '操作成功', {
                                    type: 'success',
                                    center: true,
                                    confirmButtonText:'返回列表',
                                    cancelButtonText:'留在当前页面',
                                    closeOnClickModal: false
                                }).then(() => {
                                    this.goBack();
                                }).catch(() => {
                                    this.getData();
                                })
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>